// ToDo: use this throughout the UPP?
export const logMsg = (widgetLogsEnabled: boolean, eventData: string) => {
  widgetLogsEnabled && console.log(eventData);
};
